import React from 'react'
import BaseInput from '../BaseInput'

TextInput.propTypes = BaseInput.propTypes

export default function TextInput(baseInputProps) {
  return <BaseInput type="text" {...baseInputProps} />
}
